<template>
  <div class="detail">
    <i class="icon-close gjw-iconfont gjw-icon-close" @click="close"></i>
    <component-detail ref="detail" />
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import ComponentDetail from './components/ComponentDetail'
export default {
  name: 'Detail',
  components: { ComponentDetail },
  props: {
    detail: {
      type: [Object]
    }
  },
  data() {
    return {

    }
  },
  computed: {
    ...mapGetters({
      platform: 'platform'
    })
  },
  watch: {
    'detail.id'(newVal) {
      if (newVal || newVal === 0) {
        this.$nextTick(() => {
          this.$refs.detail && this.$refs.detail.open(this.detail, this.platform)
        })
      }
    }
  },

  created() {
    this.$nextTick(() => {
      this.$refs.detail && this.$refs.detail.open(this.detail, this.platform)
    })
  },
  methods: {
    close() {
      this.$emit('close')
    }
  },
}
</script>
<style lang='less' scoped>
.detail{
  position: relative;
  width: 100%;
  height: 100%;
  padding-top: 8px;
  z-index: 9;
  .icon-close{
    position: absolute;
    right: 8px;
    cursor: pointer;
    font-size: 12px;
    z-index: 99;
  }
}

</style>
